module.exports = __webpack_public_path__ + "static/media/penguin_penguineer.e76bdc4c.png";